import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Divider,
  Stack,
  Typography,
} from '@mui/material';

import { InfoLanguage } from '@bandido/shared/enums';

import { showTextInLanguage } from '../../helpers';
import { useHotelMetadata } from '../../hooks';

export const DescriptionEditorCategory: FC<{
  categoryId: number,
  lang: InfoLanguage,
  inline?: boolean,
  onlyText?: boolean,
}> = (props) => {
  const { inline, onlyText, categoryId, lang } = props;
  const { t } = useTranslation();

  const { findCategory, findSupplierByAccessCode } = useHotelMetadata();


  const getCategoryData = () => {
    const values = {
      mappedValue: '',
      supplierValue: '',
      supplierName: '',
    };

    const category = findCategory(categoryId);

    if (category) {
      const supplierValue = showTextInLanguage(category.texts, lang);
      const supplierName = findSupplierByAccessCode(category.accessCode)?.supplierName || category.accessCode;
      values.supplierValue = supplierValue;
      values.supplierName = supplierName;
      if(category.systemMappingKey) {
        values.mappedValue = t(`hotels.categories.${category.systemMappingKey}`);
      }
      return values;
    }
    return null;
  };

  const renderCategoryMenuItem = () => {
    const categoryValues = getCategoryData();
    if (categoryValues) {;
      const { supplierName, supplierValue, mappedValue } = categoryValues;
      if(mappedValue) {
        return (
          <Stack>
            <Typography variant='subtitle2'>
              {mappedValue}
            </Typography>
            <Typography variant='body2' fontSize={10}>
              {supplierValue} {`(${supplierName})`}
            </Typography>
          </Stack>
        );
      } else {
        return (
          <Typography variant='body2' fontSize={10}>
            {supplierValue} {`(${supplierName})`}
          </Typography>
        );
      }
    }
    return <> --- </>;
  };

  const renderCategoryInLine = () => {
    const categoryValues = getCategoryData();
    if (categoryValues) {;
      const { supplierName, supplierValue, mappedValue } = categoryValues;
      if(mappedValue) {
        return (
          <Stack
            gap={1}
            direction="row"
            alignItems="center"
            divider={<Divider orientation="vertical" flexItem />}
          >
            <Typography variant='body2' fontSize={12} fontWeight={500}>
              {mappedValue}
            </Typography>
            <Typography variant='body2' fontSize={10}>
              {supplierValue} {`(${supplierName})`}
            </Typography>
          </Stack>
        );
      } else {
        return (
          <Typography variant='body2' fontSize={10}>
            {supplierValue} {`(${supplierName})`}
          </Typography>
        );
      }
    }
    return <> --- </>;
  };

  const renderOnlyText = () => {
    const categoryValues = getCategoryData();
    if (categoryValues) {;
      const { supplierValue, mappedValue } = categoryValues;
      return mappedValue || supplierValue;
    }
    return '---';
  };

  if (onlyText) {
    return renderOnlyText();
  } else if (inline) {
    return  renderCategoryInLine();
  } else {
    return renderCategoryMenuItem();
  }
};
